import { render, staticRenderFns } from "./DevToolsPage.vue?vue&type=template&id=9cb6aff0&scoped=true&"
import script from "./DevToolsPage.vue?vue&type=script&lang=js&"
export * from "./DevToolsPage.vue?vue&type=script&lang=js&"
import style0 from "./DevToolsPage.vue?vue&type=style&index=0&id=9cb6aff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb6aff0",
  null
  
)

export default component.exports